/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seat: NonNullable<unknown> }} Vp_Blocked_Oust_OrderInputs */



/**
* | output |
* | --- |
* | "These VPs are impossible: no one could have ousted seat {seat}." |
*
* @param {Vp_Blocked_Oust_OrderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_blocked_oust_order = /** @type {((inputs: Vp_Blocked_Oust_OrderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_Blocked_Oust_OrderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ces VP sont impossibles : personne n'a pu éliminer le siège ${i?.seat}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Estos VP son imposibles: nadie pudo haber eliminado el asiento ${i?.seat}.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Estes VP são impossíveis: ninguém poderia ter eliminado o lugar ${i?.seat}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questi VP sono impossibili: nessuno può aver eliminato il posto ${i?.seat}.`)
	return /** @type {LocalizedString} */ (`These VPs are impossible: no one could have ousted seat ${i?.seat}.`)
});